$mol_svg_root $mol_svg
	dom_name \svg
	attr *
		^
		viewBox <= view_box \0 0 100 100
		preserveAspectRatio <= aspect \xMidYMid
